import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Mug = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M8 0v3H6V0h2zM4 0v3H2V0h2zm8 0v3h-2V0h2zM15 5H1c-.6 0-1 .4-1 1v7c0 1.7 1.3 3 3 3h7c1.7 0 3-1.3 3-3v-2c1.7 0 3-1.3 3-3V6c0-.6-.4-1-1-1zm-1 3c0 .6-.4 1-1 1V7h1v1z" />
    </svg>
  );
};

Mug.displayName = 'Mug';
